import { useEffect, useState } from "react"
import { Data, Modal, ModalId, useUIState } from "../../../../ui"
import { EmailForm } from "./emailForm"

type Props = {
    data?: Data
    onSubmit: (email: string) => void
}

export const EmailFormModal = (props: Props) => {
    const { data, onSubmit } = props
    const [key, setKey] = useState(0)
    const { openedModal } = useUIState()

    useEffect(() => setKey(key + 1), [openedModal])
    
    return (
        <Modal
            modalId={ModalId.EMAIL_FORM}
            title="Agregar Email"
            actions={[]}
        >
            <EmailForm
                key={key}
                data={data}
                onSubmit={onSubmit}
            />
        </Modal>
    )
}
